const paymentDetailsMethod = {
  BANK_TRANSFER: 'bank-transfer',
  SWISH: 'swish',
} as const;

const paymentDetailsMethodChoices = [
  {
    id: paymentDetailsMethod.BANK_TRANSFER,
    name: 'Bank transfer',
  },
  {
    id: paymentDetailsMethod.SWISH,
    name: 'Swish',
  },
];

export default paymentDetailsMethodChoices;
